import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  dateFormatter,
  dropdownFetch,
  getCurrentDateTime,
  getISTDate,
  getKeyPathValue,
  request,
  toast
} from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { OPDBillingDetailForm } from './OPDBillingDetailForm';
import { BANK_CASH, BILL_TYPE, PAY_MODES, PAY_MODES_CASH, RECEIPT_MODE, YES_NO } from '../../../../../constants';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';

function formatDate(dateString) {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); 
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

const BILL_TABLE_HEADER = [
  {
    header: 'Type',
    accessor: 'type'
  },
  {
    header: 'Operating Doctor',
    accessor: 'doctor'
  },
  {
    header: 'Service Name',
    accessor: (row)=> row?.serviceName || row?.service_name
  },
  {
    header: 'Qty',
    accessor: 'quantity'
  },
  {
    header: 'Rate',
    accessor: 'rate'
  },
  {
    header: 'Amount',
    accessor: 'amount'
  },
  {
    header: 'Disc. Amt',
    accessor: 'disc_amt'
  },
  {
    header: 'Net Amount',
    accessor: 'net_amt'
  }
];

const PATIENT_TABLE_HEADER = [
  { header: 'UHID', accessor: 'uhid' },
  { header: 'OP No', accessor: 'op_no' },
  { header: 'Created At', accessor: (row) => formatDate(row?.date) },
  { header: 'Patient Name', accessor: (row) => `${row?.name_suffix} ${row?.first_name} ${row?.last_name}` },
  { header: 'Mobile No', accessor: 'address.mobile' },
  { header: 'Doctor', accessor: 'consultant.name' },
  { header: 'Address', accessor: 'address.address' }
];

const TABLE_HEADER = [
  {
    header: 'Bill No',
    accessor: 'bill_no'
  },
  {
    header: 'Bill Date',
    accessor: (row) => `${getCurrentDateTime('date', row.date)}`
  },
  {
    header: 'UHID No',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.patient?.name}`}
        </span>
      );
    }
  },
  {
    header: 'Sponsor',
    accessor: 'patient.sponsor_name'
  },
  {
    header: 'Mobile No',
    accessor: 'patient.mobile_no'
  },
  {
    header: 'Net Amount',
    accessor: 'net_amt'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const REQUISITION_TABLE_HEADER = [
  {
    header: 'Doc No',
    accessor: 'doc_no'
  },
  {
    header: 'UHID No',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.patient?.name}`}
        </span>
      );
    }
  },
  {
    header: 'Mobile No',
    accessor: 'patient.mobile_no'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const initialOPDBillingDataObj = {
  data: [],
  loading: false
};

export const OPDBilling = () => {
  const doctorIDRef = useRef();
  const sponsorIDRef = useRef();
  const { pathname,search } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [addDetailsDialogOpen, setAddDetailsDialogOpen] = useState(false);
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [selectedRows,setSelectedRows] = useState();
  const [opdBillingDataObj, setOpdBillingDataObj] = useState(initialOPDBillingDataObj);
  const [opdTodayBillingDataObj, setOpdTodayBillingDataObj] = useState(initialOPDBillingDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [openQueryTodayDialog, setOpenQueryTodayDialog] = useState(false);
  const [searchPatientRegisterationDialog, setSearchPatientRegisterationDialog] = useState(false);
  const [patientDetailList, setPatientDetailList] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [input, setInput] = useState('');
  const [inputToday, setInputToday] = useState('');
  const [patientInput, setPatientInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [patientDataList, setPatientDataList] = useState([]);
  const [serviceDropdown, setSeriveDropdown] = useState([]);
  const [testDropdown, setTestDropdown] = useState([]);
  const user = JSON.parse(localStorage.getItem('user'));
  const netAmtRef = useRef(0);
  const [startDateInput,setStartDateInput] = useState('')
  const [endDateInput,setEndDateInput] = useState('')
  const [editData, setEditData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [patientData,setPatientData]= useState([])
  const [opdRequisitionDialog,setOpdRequisitionDialog] = useState(false)
  const [opdRequisitionData,setOpdRequisitionData] = useState(false)

  const isEnabledDate =
    user && user.permissions ? user.permissions.some((permission) => permission.includes('DatePermission')) : false;

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        uhid: Yup.string().required(' '),
        patient_name: Yup.string().required(' '),
        opd_type: Yup.string().required(' '),
        ref_type: Yup.string().required(' '),
        doctor: Yup.string().required(' '),
        sponsor: Yup.string().required(' '),
        department: Yup.string().required(' '),
        bill: Yup.object().shape({
          rec_amt_1: Yup.number().min(0, ' '),
          rec_amt_2: Yup.number().min(0, ' '),
          pay_mode: Yup.string().required(' ')
        })
      })
    ),
    defaultValues: {
      bill: {
        date: getISTDate(),
        time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
        pay_mode:"CASH",
        out_sourced: 'No',
        // rec_amt_1: 0,
        // rec_amt_2: 0,
        tds_amt: 0,
        disc_per: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;
  const discAmt = watch('bill.disc_amt'); // Watch discount amount
  const netAmtWatch = watch('bill.net_amt'); // Watch net amount
  const recAmt1Watch = watch('bill.rec_amt_1');
  const recAmt2Watch = watch('bill.rec_amt_2');
  const payMode = watch('bill.pay_mode');
  const discPer = watch('bill.disc_per'); // Watch discount percentage

  // Calculate the initial values from the detailList
  useEffect(() => {
    let total_qty = 0;
    let total_amt = 0;
    let gst_amt = 0;
    let net_amt = 0;

    if (detailList) {
      detailList.forEach((detail) => {
        total_qty += detail.quantity;
        total_amt += detail.amount;
        gst_amt += detail.gst_amt;
        net_amt += detail.net_amt;
      });
    }

    // Set initial values for total amount, net amount, and other fields
    setValue('bill.total_qty', total_qty);
    setValue('bill.total_amt', total_amt);
    setValue('bill.gst_amt', gst_amt);
    setValue('bill.net_amt', net_amt); // Set the initial net_amt from the detailList
    netAmtRef.current = net_amt; // Store initial net_amt in useRef
  }, [detailList, setValue]);

  // Handle discount changes and adjust the net amount
  useEffect(() => {
    if (discAmt && netAmtWatch) {
      const adjustedNetAmt = netAmtRef.current - discAmt; // Subtract the discount from the initial net amount

      // Update the fields with the adjusted values
      setValue('bill.net_amt', adjustedNetAmt); // Update net_amt after discount
      setValue('bill.rec_amt_1', adjustedNetAmt); // Set rec_amt_1 to the adjusted net amount
      setValue('bill.total_recpt', adjustedNetAmt); // Set total_recpt to the adjusted net amount

      // Calculate and set the discount percentage
      const calculatedDiscPer = ((discAmt / netAmtRef.current) * 100).toFixed(2); // Calculate discount percentage
      setValue('bill.disc_per', parseFloat(calculatedDiscPer)); // Update disc_per with calculated value
    }
  }, [discAmt, netAmtWatch, setValue]);

  // Handle receipt and balance amount calculation based on payment mode
  useEffect(() => {
    const total_recpt = +recAmt1Watch + +recAmt2Watch;
    let balanceAmt = netAmtWatch - total_recpt;
    if (payMode === 'CASH') {
      setValue('bill.rec_amt_1', netAmtWatch); // Set the total net amount after discount to rec_amt_1
      setValue('bill.rec_amt_2', 0); // Clear rec_amt_2
      setValue('bill.balance_amt', 0); // Set balance amount to 0
      setValue('bill.total_recpt', netAmtWatch); // Set total receipt to net amount after discount
    } else if (['Bank', 'UPI', 'Paytm', 'RTGS/NEFT/Cheque', 'Credit Card', 'Debit Card'].includes(payMode)) {
      setValue('bill.rec_amt_1', 0); // Clear rec_amt_1 for non-cash payment modes
      setValue('bill.rec_amt_2', netAmtWatch); // Set the total net amount after discount to rec_amt_2
      setValue('bill.balance_amt', 0); // Set balance amount to 0
      setValue('bill.total_recpt', netAmtWatch); // Set total receipt to net amount after discount
    } else if (payMode === 'Credit') {
      setValue('bill.rec_amt_1', 0); // Clear rec_amt_1 for credit payment
      setValue('bill.rec_amt_2', 0); // Clear rec_amt_2 for credit payment
      setValue('bill.balance_amt', balanceAmt); // Set balance amount to remaining balance
      setValue('bill.total_recpt', 0); // Set total receipt to 0 since no payment is made
    } else {
      // Default case when no payment mode is matched
      setValue('bill.total_recpt', total_recpt);
      setValue('bill.balance_amt', balanceAmt);
    }
  }, [netAmtWatch, recAmt1Watch, recAmt2Watch, payMode, setValue]);

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      console.log(selectedRecord,"SELECTEDRECORD IS HERE !")
      setValue('uhid', selectedRecord.uhid);
      const formattedbillDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : '';
      setValue('bill.date', formattedbillDate);
      setValue('bill.time', selectedRecord?.time);
      setDetailList(selectedRecord?.service_items);
      searchPatientHandler(selectedRecord?.uhid);
    } else {
      reset();
    }
  }, [selectedRecord]);


  useEffect(() => {
    if (selectedRows) {
      const keyValuePair = getKeyPathValue(selectedRows, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      console.log(selectedRows,"SELECTEDRECORD IS HERE !")
      setValue('uhid', selectedRows.uhid);
      const formattedbillDate = selectedRows?.date ? new Date(selectedRows.date).toISOString().split('T')[0] : '';
      setValue('bill.date', formattedbillDate);
      setValue('bill.time', selectedRecord?.time);
      setDetailList(selectedRows?.service_items);
      searchPatientHandler(selectedRows?.uhid);
    } else {
      reset();
    }
  }, [selectedRows]);

  const getServiceDropdown = useCallback(async () => {
    const data = await dropdownFetch('service');
    setSeriveDropdown(data);
  }, []);

  const getTestDropdown = useCallback(async () => {
    const data = await dropdownFetch('lis-test');
    setTestDropdown(data);
  }, []);

  useEffect(() => {
    getServiceDropdown();
    getTestDropdown();
  }, [getServiceDropdown, getTestDropdown]);

  const formSubmit = async (formValues) => {
    if (detailList.length === 0) {
      toast('Please add the service first', { variant: 'warning' });
      return;
    }
    setLoading(true);
    const payload = { 
      ...formValues,
      ...formValues.bill,
      uhid: formValues.uhid,
      service_items: detailList,
      ...(selectedRows && { opd_requisition_id: selectedRows._id }),
     };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit'){
      editFlag = true;
    }
    const response = await request(editFlag ? '/opd-billing-edit' : '/opd-billing-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} OPD Bill`, { variant: 'success' });
      if (editFlag) {
        setDetailList([]);
        reset();
        setCurrentAction();
        setPatientData([])
      } else {
        setSelectedRecord(response.data);
        setDetailList([]);
        reset();
        setCurrentAction();
      }
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} OPD Bill`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleRowDelete = (rowId) => {
    setDetailList((prev) => prev.filter((data,index) =>  index !== rowId));
  };

  const onDetailAddHandler = (data) => {
    const existingDetail = detailList.find(({ service }) => service === data.service);
    if (existingDetail) {
      toast('OPD Type Service already chosen', { variant: 'error' });
      return;
    }
    if (isEditMode){
      console.log(isEditMode,"HEY EDIT MODE IS HERE")
      const updatedDetailList = detailList.map((detail,index) =>{
        return index === data._id ? { ...detail, ...data } : detail
    });
      setDetailList(updatedDetailList);
      toast('Service updated successfully', { variant: 'success' });
    } else {
      const serviceName = serviceDropdown.find(({ _id }) => _id === data.service)?.service_name;
      const testName = testDropdown.find(({ _id }) => _id === data.service)?.test_name;
      setDetailList((prev) => [
        ...prev,
        {
          ...data,
          service_name: serviceName || testName,
        },
      ]);
      toast('Service added successfully', { variant: 'success' });
    }
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/opd-billing-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel OPD Bill', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel OPD Bill', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/opd-billing-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted OPD Bill', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete OPD Bill', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setOpdBillingDataObj({ loading: true });
    const response = await request('/opd-billing-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setOpdBillingDataObj({ loading: false, data: filteredData });
      setOriginalData(sortedData);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setOpdBillingDataObj({ loading: false });
    }
  };

  const TodayBilling = async () => {
    setOpenQueryTodayDialog(true);
    setOpdTodayBillingDataObj({ loading: true, data: [] });
    const query = {};

    query.today = 1;
    const response = await request('/opd-billing-list', {
      method: 'GET',
      query: query
    });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setOpdTodayBillingDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setOpdTodayBillingDataObj({ loading: false, data: [] });
    }
  };

  const searchPatientHandler = async (uhid = null) => {
    if (typeof uhid !== 'number' && typeof uhid !== 'string') uhid = null;
    setLoading(true);
    if (!uhid) setSearchPatientRegisterationDialog(true);
    const response = await request('/patient-registeration-search', { method: 'GET', query: { uhid } });
    if (response?.success) {
      const patientMap = {};
      response.data.forEach((patient) => {
        if (!patientMap[patient.uhid] || patientMap[patient.uhid].op_no < patient.op_no) {
          patientMap[patient.uhid] = patient;
        }
      });
      const latestPatients = Object.values(patientMap);
      if (uhid) {
        const patientData = latestPatients.find((data) => {
          console.log('UHID:', uhid);
          console.log('Patient Data:', data); 
          return data?.uhid === uhid;
        });
        if (patientData) {
          setValue('visit', patientData?.visit_no);
          setValue('op', patientData?.op_no);
          setValue('patient_name', `${patientData?.first_name} ${patientData?.last_name}`);
          setValue('patient_suffix', patientData?.name_suffix);
          setValue('opd_type', patientData?.opd_type?.type);
          setValue('ref_type', patientData?.ref_by?.referral_name);
          setValue('application_no', patientData?.app_no_date);
          setValue('doctor', patientData?.consultant?.name);
          doctorIDRef.current = patientData?.consultant?._id;
          setValue('department', patientData?.department?.department);
          setValue('sponsor', patientData?.sponsor?.name);
          setValue('remarks', patientData?.remarks);
          setValue('queue_no', patientData?.app_no_date);
          setValue('card_no', patientData?.chq_card_no);
          setValue('vertical', patientData?.vertical?.verticalname);
        }
      } else {
        setPatientDetailList(latestPatients.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
        setPatientDataList(latestPatients.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (opdBillingDataObj.data && opdBillingDataObj.data.length > 0) {
      setOriginalData(opdBillingDataObj.data);
      setIsFiltered(false);
    }
  }, [opdBillingDataObj.data]);

  const handleUhidSearch = async () => {
    const lowercasedInput = patientInput.toLowerCase().trim();

    try {
      const response = await request('/patient-registeration-search', {
        method: 'GET',
        query: { name: lowercasedInput }
      });
      if (response.success) {
        setOpdBillingDataObj({ loading: false, data: response.data });
        setPatientDataList(response.data);
      } else {
        toast('Error in fetching dataaaaa', { variant: 'error' });
        setPatientDataList({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setPatientDataList({ loading: false, data: [] });
    }
  };

  useEffect(() => {
    if (patientDetailList.data && patientDetailList.data.length > 0) {
      setPatientDataList(patientDetailList.data);
      setIsFiltered(false);
    }
  }, [patientDetailList]);

  const handlePatientData = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    setOpdBillingDataObj({ loading: true, data: [] });
    try {
      const query = {};
      if (startDateInput && endDateInput) {
        query.startDate = startDateInput ;
        query.endDate = endDateInput;
      }
      if (lowercasedInput) {
        query.patientName = lowercasedInput;
      }
      const response = await request('/opd-billing-list', {
        method: 'GET',
        query: query
      });
      if (response.success && Array.isArray(response.data)) {
        const filteredData = response.data.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setOpdBillingDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setOpdBillingDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setOpdBillingDataObj({ loading: false, data: [] });
    }
  };

  const handlePatientDataToday = async () => {
    const lowercasedInput = inputToday.toLowerCase().trim();
    setOpdTodayBillingDataObj({ loading: true, data: [] });
    try {
      const query = {};
      query.today = 1;
      query.patientName = lowercasedInput;
      const response = await request('/opd-billing-list', {
        method: 'GET',
        query: query
      });
      if (response.success && Array.isArray(response.data)) {
        const filteredData = response.data.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setOpdTodayBillingDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setOpdTodayBillingDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setOpdTodayBillingDataObj({ loading: false, data: [] });
    }
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const handleChangeToday = (e) => {
    const newInput = e.target.value;
    setInputToday(newInput);
  };

  useEffect(() => {
    handlePatientDataToday();
  }, [inputToday]);

  const handleInputChange = (e) => {
    const newInput = e.target.value;
    setPatientInput(newInput);
  };

  useEffect(() => {
    handlePatientData();
  }, [input]);

  useEffect(() => {
    handleUhidSearch();
  }, [patientInput]);


 const handleStartChangeDate =(e)=>{
  setStartDateInput(e.target.value)
 }

 const handleEndChangeDate =(e)=>{
  setEndDateInput(e.target.value)
 }

 const handleSearchByDate= async()=>{
  setOpdBillingDataObj({ loading: true, data: [] });
  try {
    const query = {};
    if (startDateInput && endDateInput) {
      query.startDate = startDateInput ;
      query.endDate = endDateInput;
    }
    const response = await request('/opd-billing-list', {
      method: 'GET',
      query: query
    });

    if (response.success && Array.isArray(response.data)) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setOpdBillingDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setOpdBillingDataObj({ loading: false, data: [] });
    }
  } catch (error) {
    console.error('Error during search:', error);
    toast('Error during search', { variant: 'error' });
    setOpdBillingDataObj({ loading: false, data: [] });
  }
 }

 
 const handleRowEdit = (row) => {
  setAddDetailsDialogOpen(true);
  setEditData(row);
  setIsEditMode(true);
};

const queryParams = new URLSearchParams(search);
const UHID = queryParams.get('uhid');

const fetchPatientData = async () => {
  const lowercasedInput = UHID?.toLowerCase();
  if (!lowercasedInput) {
    toast('UHID is missing in the URL', { variant: 'warning' });
    return;
  }
  try {
    const response = await request('/patient-registeration-search', {
      method: 'GET',
      query: { name: lowercasedInput },
    });
    if (response.success && response.data.length > 0) {
      const patient = response.data[0];
      setPatientData(patient);
      if(patientData){
        setValue('uhid', patient.uhid);
        setValue('patient_suffix', patient.name_suffix || '');
        setValue('patient_name', `${patient?.first_name || ''} ${patient?.last_name || ''}`);
        setValue('doctor', patient.consultant?.name || '');
        setValue('vertical', patient.vertical?.verticalname || '');
        setValue('opd_type', patient.opd_type?.type || '');
        setValue('department', patient.department?.department || '');
        setValue('ref_type', patient.ref_by?.referral_name || '');
        setValue('sponsor', patient.sponsor?.name || '');
        sponsorIDRef.current = patient?.sponsor?._id;
        doctorIDRef.current = patient?.consultant?._id;
        toast('Fetching data successfully', { variant: 'success' });
      }
      window.history.replaceState(null,'',window.location.pathname);
    } else {
      toast('No patient data found', { variant: 'error' });
    }
  } catch (error) {
    console.error('Error during search:', error);
    toast('Error during search', { variant: 'error' });
  }
};

useEffect(() => {
  if (UHID) {
    fetchPatientData();
  }
}, [UHID]);


const isActionAllowed = ['new', 'edit'].includes(currentAction);
const isPayModeForMode1 = ['CASH', 'Both'].includes(payMode);
const isPayModeForMode2 = ['Bank', 'Both', 'Credit Card', 'Debit Card', 'UPI', 'RTGS/NEFT/Cheque', 'Paytm'].includes(payMode);
const isCredit = payMode === 'Credit';


useEffect(() => {
  const payModeMap = {
    CASH: { pay_mode_1: "CASH", pay_mode_2: "" },
    Bank: { pay_mode_1: "", pay_mode_2: "Bank" },
    "Credit Card": { pay_mode_1: "", pay_mode_2: "Credit Card" },
    "Debit Card": { pay_mode_1: "", pay_mode_2: "Debit Card" },
    UPI: { pay_mode_1: "", pay_mode_2: "UPI" },
    "RTGS/NEFT/Cheque": { pay_mode_1: "", pay_mode_2: "RTGS/NEFT/Cheque" },
    Paytm: { pay_mode_1: "", pay_mode_2: "Paytm" },
    Both: { pay_mode_1: "", pay_mode_2: "" },
    Credit: { pay_mode_1: "", pay_mode_2: "" },
  };
  const selectedMode = payModeMap[payMode] || { pay_mode_1: "", pay_mode_2: "" };
  setValue('bill.pay_mode_1', selectedMode.pay_mode_1);
  setValue('bill.pay_mode_2', selectedMode.pay_mode_2);
}, [payMode, setValue]);


const handleOpdRequisition = async () => {
  setOpdRequisitionDialog(true);
  setOpdRequisitionData({ loading: true });
  const response = await request('/opd-requisition-saved-list', { method: 'GET' });
  if (response.success) {
    const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    const filteredData = response.data.filter(
      (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
    );
    setOpdRequisitionData({ loading: false, data: filteredData });
  } else {
    toast('Error in fetching data', { variant: 'error' });
    setOpdRequisitionData({ loading: false });
  }
};

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: '100vw',
            boxSizing: 'border-box',
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                OPD Billing
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                    if (!patientData) {
                      reset();
                    }
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={TodayBilling}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Today Billing
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleOpdRequisition}
                  disabled={!['new', 'edit'].includes(currentAction)}
                >
                  Opd Requisitions
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>UHID/OP/Visit</Typography>
                    <TextField sx={{ flex: 0.35 }} name="uhid" disabled />
                    <TextField sx={{ flex: 0.175 }} name="op" disabled />
                    <TextField sx={{ flex: 0.175 }} placeholder="Visit No." name="visit" disabled />
                    <Button
                      disabled={!['new'].includes(currentAction)}
                      sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                      variant="contained"
                      onClick={searchPatientHandler}
                    >
                      <SearchIcon />
                    </Button>
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                    <TextField disabled={true} sx={{ flex: 0.25 }} name="patient_suffix" />
                    <TextField disabled={true} sx={{ flex: 0.55 }} placeholder="Patient Name" name="patient_name" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>OPD Type</Typography>
                    <TextField disabled={true} sx={{ flex: 0.8 }} placeholder="Select OPD" name="opd_type" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Ref. Type</Typography>
                    <TextField disabled={true} sx={{ flex: 0.8 }} placeholder="Select Ref" name="ref_type" />
                  </Stack>
                  {/* <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Aca.Jr.Id.</Typography>
                    <TextField disabled={true} sx={{ flex: 0.8 }} placeholder="Select Academic Jr." name="aca_jr_id" />
                  </Stack> */}
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>App/Bill No.</Typography>
                    <TextField disabled={true} sx={{ flex: 0.4 }} placeholder="App No." name="application_no" />
                    <TextField disabled={true} sx={{ flex: 0.4 }} placeholder="Bill No." name="bill.bill_no" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doctor</Typography>
                    <TextField disabled={true} name="doctor" sx={{ flex: 0.8 }} placeholder="Select Doctor" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Department</Typography>
                    <TextField disabled={true} sx={{ flex: 0.8 }} name="department" placeholder="Department" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Sponsor</Typography>
                    <TextField disabled={true} sx={{ flex: 0.8 }} name="sponsor" placeholder="Sponsor" />
                  </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Bill Date/Time</Typography>
                    <TextField
                      sx={{ flex: 0.5 }}
                      name="bill.date"
                      placeholder="Date"
                      type="date"
                      disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                    />
                    <TextField
                      sx={{ flex: 0.3 }}
                      name="bill.time"
                      placeholder="Time"
                      type="time"
                      disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Vertical</Typography>
                    <TextField disabled={true} sx={{ flex: 0.8 }} name="vertical" placeholder="Select Vertical" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Out Sourced</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      name="bill.out_sourced"
                      placeholder="Select out sourced service provider"
                      menus={YES_NO}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="remarks"
                      placeholder="Remarks"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Stack spacing={1} direction="row" justifyContent="space-between">
                    <Stack spacing={1} direction="row">
                      {/* <Button variant="contained" color="grey">
                      Bill Discount
                    </Button>
                    <Button variant="contained" color="grey">
                      Medicine Print
                    </Button> */}
                    </Stack>
                    <Button
                      variant="contained"
                      disabled={!['new', 'edit'].includes(currentAction) || !watch('doctor')}
                      onClick={() => {
                        setAddDetailsDialogOpen(true);
                        setIsEditMode(false);
                      }}
                    >
                      Add Details
                    </Button>
                  </Stack>
                  <Table
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={detailList.map((data, index) => ({ _id: index, ...data }))}
                    columns={BILL_TABLE_HEADER}
                    size="small"
                    showEditButton={['new', 'edit'].includes(currentAction) && true}
                    handleDeleteRow={handleRowDelete}
                    showEditAction={true}
                    handleRowEdit={handleRowEdit}
                    onClickEditRow={handleRowEdit}
                  />
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  {/* <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Bill Type</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="bill.bill_type"
                    placeholder="Select Bill Type"
                    menus={BILL_TYPE}
                  />
                </Stack> */}
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Pay Mode</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8, border: currentAction ? '0.5px solid red' : '' }}
                      name="bill.pay_mode"
                      placeholder="Pay Mode"
                      menus={RECEIPT_MODE}
                      onChange={() => setValue('bank_cash', '')}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Pay Mode1/2</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction) || payMode !== 'Both'}
                      formControlSX={{ flex: 0.4, border: currentAction ? '0.5px solid red' : '' }}
                      name="bill.pay_mode_1"
                      placeholder="Select Pay Mode1"
                      menus={PAY_MODES_CASH}
                    />
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction) || payMode !== 'Both'}
                      formControlSX={{ flex: 0.4, border: currentAction ? '0.5px solid red' : '' }}
                      name="bill.pay_mode_2"
                      placeholder="Select Pay Mode2"
                      menus={PAY_MODES}
                    />
                  </Stack>
                  {/* <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Bank/Cash</Typography>
                  <SelectTag
                    formControlSX={{ flex: 0.8 }}
                    disabled={!['new', 'edit'].includes(currentAction)}
                    name="bill.bank_cash"
                    placeholder="Bank / Cash"
                    menus={BANK_CASH.filter(
                      ({ type }) => type === RECEIPT_MODE.filter((mode) => mode._id === watch('bill.pay_mode'))[0]?.type
                    )}
                  />
                </Stack> */}
                  {/* <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Cheque No.</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8 }}
                    name="bill.cheque_no"
                    placeholder="Cheque No"
                  />
                </Stack> */}
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Auth Code</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="bill.auth_code"
                      placeholder="Auth Code"
                    />
                  </Stack>
                  {/* <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Service Disc.</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8 }}
                    name="bill.service_disc"
                    placeholder="Service Discount"
                  />
                </Stack> */}
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total Qty/Amt</Typography>
                    <TextField disabled sx={{ flex: 0.3 }} name="bill.total_qty" placeholder="Qty" />
                    <TextField disabled sx={{ flex: 0.5 }} name="bill.total_amt" placeholder="Amt" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Dis per/ Amt</Typography>
                    <TextField disabled sx={{ flex: 0.4 }} name="bill.disc_per" placeholder="Disc. %" />
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction) || !watch('bill.pay_mode')}
                      sx={{ flex: 0.4 }}
                      name="bill.disc_amt"
                      placeholder="Disc. Amt"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Net Amt</Typography>
                    {/* <TextField disabled sx={{ flex: 0.4 }} name="bill.gst_amt" placeholder="GST Amount" /> */}
                    <TextField disabled sx={{ flex: 0.8 }} name="bill.net_amt" placeholder="Net Amount" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>RecAmt 1&2</Typography>
                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={
                        !['new', 'edit'].includes(currentAction) ||
                        payMode === 'Credit' ||
                        payMode === 'Bank' ||
                        payMode === 'UPI' ||
                        payMode === 'Paytm' ||
                        payMode === 'RTGS/NEFT/Cheque' ||
                        payMode === 'Credit Card' ||
                        payMode === 'Debit Card'
                      }
                      type="number"
                      inputProps={{ min: '0' }}
                      name="bill.rec_amt_1"
                      placeholder="Cash"
                    />
                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={!['new', 'edit'].includes(currentAction) || payMode === 'Credit' || payMode === 'CASH'}
                      type="number"
                      inputProps={{ min: '0' }}
                      name="bill.rec_amt_2"
                      placeholder="Bank"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total Recpt.</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="bill.total_recpt" placeholder="Total" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Balance Amount</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="bill.balance_amt" placeholder="Balance Amount" />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          direction="row"
          spacing={1}
          justifyContent="space-between"
          alignItems="center"
          sx={{
            mb: 0,
            borderColor: 'grey.300'
          }}
        >
          <Typography variant="h4" fontWeight="bold">
            OPD Billing Query Window
          </Typography>
          <IconButton
            onClick={() => {
              setOpenQueryDialog(false);
              setStartDateInput('');
              setEndDateInput('');
            }}
          >
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem'
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="center"
          sx={{
            mt: 1,
            mb: 1,
            width: '60%',
            gap: 2,
            justifyContent: 'space-between'
          }}
        >
          <Typography
            sx={{
              flex: 1,
              fontWeight: 700,
              fontSize: '1.4rem',
              textAlign: 'center' // Centers the label text
            }}
          >
            From Date
          </Typography>

          <MuiTextField
            sx={{
              flex: 2, // This ensures the input takes more space
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            variant="outlined"
            name="from_date"
            type="date"
            onChange={handleStartChangeDate}
            value={startDateInput}
          />

          <Typography
            sx={{
              flex: 1,
              fontWeight: 700,
              fontSize: '1.4rem',
              textAlign: 'center' // Centers the label text
            }}
          >
            To Date
          </Typography>

          <MuiTextField
            sx={{
              flex: 2, // This ensures the input takes more space
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            name="to_date"
            variant="outlined"
            type="date"
            onChange={handleEndChangeDate}
            value={endDateInput}
          />
          <Button variant="contained" disabled={!startDateInput || !endDateInput} onClick={handleSearchByDate}>
            Search
          </Button>
        </Stack>

        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={opdBillingDataObj?.data || []}
          loading={opdBillingDataObj.loading}
          onRowClick={(row) => {
            sponsorIDRef.current = row?.patient?.sponsor;
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        open={openQueryTodayDialog}
        onClose={() => setOpenQueryTodayDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" borderColor="grey.300">
          <Typography variant="h4" fontWeight="bold">
            Today OPD Billing Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryTodayDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '16px',
                fontWeight: '700'
              },
              '& .MuiOutlinedInput-input': {
                padding: '6px 14px'
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={inputToday}
            onChange={handleChangeToday}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={opdTodayBillingDataObj?.data || []}
          loading={opdTodayBillingDataObj.loading}
          onRowClick={(row) => {
            delete row.patient;
            setSelectedRecord(row);
            setOpenQueryTodayDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        open={addDetailsDialogOpen}
        onClose={() => setAddDetailsDialogOpen(false)}
        PaperProps={{ sx: { width: '80%', height: '90vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <OPDBillingDetailForm
          doctorID={doctorIDRef.current}
          sponsorID={sponsorIDRef.current}
          onClose={() => setAddDetailsDialogOpen(false)}
          onAdd={onDetailAddHandler}
          serviceDropdown={serviceDropdown}
          testDropdown={testDropdown}
          editData={editData}
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
          setEditData={setEditData}
        />
      </Dialog>
      <Dialog
        open={opdRequisitionDialog}
        onClose={() => setOpdRequisitionDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" borderColor="grey.300">
          <Typography variant="h4" fontWeight="bold">
            Opd Requisition Detail Window
          </Typography>
          <IconButton onClick={() => setOpdRequisitionDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={REQUISITION_TABLE_HEADER}
          data={opdRequisitionData?.data || []}
          loading={opdRequisitionData.loading}
          onRowClick={(row) => {
            setSelectedRows(row);
            setOpdRequisitionDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        open={searchPatientRegisterationDialog}
        onClose={() => setSearchPatientRegisterationDialog(false)}
        maxWidth="xl"
        scroll="body"
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" borderColor="grey.300">
          <Typography variant="h4" fontWeight="bold">
            Patient Query Window
          </Typography>
          <IconButton onClick={() => setSearchPatientRegisterationDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '16px',
                fontWeight: '700'
              },
              '& .MuiOutlinedInput-input': {
                padding: '6px 14px'
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={patientInput}
            onChange={handleInputChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={PATIENT_TABLE_HEADER}
          data={patientDataList || []}
          onRowClick={(row) => {
            setValue('uhid', row.uhid);
            setValue('visit', row.visit_no);
            setValue('op', row.op_no);
            setValue('patient_name', `${row?.first_name} ${row?.last_name}`);
            setValue('patient_suffix', row.name_suffix);
            setValue('opd_type', row.opd_type?.type);
            setValue('ref_type', row.ref_by?.referral_name);
            setValue('application_no', row.app_no_date);
            setValue('doctor', row.consultant?.name);
            doctorIDRef.current = row.consultant?._id;
            setValue('department', row.department?.department);
            setValue('sponsor', row.sponsor?.name);
            sponsorIDRef.current = row?.sponsor?._id;
            setValue('remarks', row.remarks);
            setValue('queue_no', row.app_no_date);
            setValue('card_no', row.chq_card_no);
            setValue('vertical', row.vertical?.verticalname);
            setSearchPatientRegisterationDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
